export const TOGGLE_ALL_VALUE = "toggle-all";
